/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "1",
    spendId: "23",
    unit: "Thùng",
    title: "Sản lượng dầu lãi được chia tạm tính",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "2",
    spendId: "24",
    unit: "USD/Thùng",
    title: "Giá cơ sở của năm",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "3",
    spendId: "25",
    unit: "USD/Thùng",
    title: "Giá bán dầu thô trung bình",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "4",
    spendId: "",
    unit: "",
    title: "Xác định số phụ thu tạm tính:",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "4.1",
    spendId: "26",
    unit: "USD",
    title: "Đối với các dự án dầu khí khuyến khích đầu tư: [26] = 30%*{[25]-1,2*[24]}*[23]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "4.2",
    spendId: "",
    unit: "",
    title: "Đối với các dự án dầu khí không thuộc khoản 4.1:",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "27",
    unit: "USD",
    title: "a) Trường hợp {1,2*[24]} < [25] <= {1,5*[24]}: [27] = 50%*{[25]-1,2*[24]}*[23]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "",
    unit: "",
    title: "b) Trường hợp [25] > {1,5*[24]}:",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "28",
    unit: "USD",
    title: "- Phụ thu theo mức 50% [28] = 50%*{1,5*[24]-1,2*[24]}*[23]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "29",
    unit: "USD",
    title: "- Phụ thu theo mức 60% [29] = 60%*{[25]-1,5*[24]}*[23]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "5",
    spendId: "30",
    unit: "USD",
    title: "Số phụ thu tạm tính phải nộp:",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "",
    unit: "USD",
    title: "a) Đối với trường hợp thuộc khoản 4.1: [30] = [26]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "",
    unit: "USD",
    title: "b) Đối với trường hợp thuộc điểm a khoản 4.2: [30] = [27]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "",
    unit: "USD",
    title: "c) Đối vơi trường hợp thuộc điểm b khoản 4.2: [30] = [28]+[29]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "6",
    spendId: "31",
    unit: "USD/VNĐ",
    title: "Tỷ giá quy đổi",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (spendId) => ["26", "27", "28", "29", "30"].includes(spendId) || !spendId;

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Mã số
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đơn vị
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Giá trị
              </Td>
            </tr>

            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (5)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: 800,
                  }}
                >
                  {item.spendId ? `[${item.spendId}]` : ""}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.unit}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {isDisabled(item.spendId) ? (
                    "0,00"
                  ) : (
                    <InputTable
                      id={item.id}
                      value={item.value5}
                      name="value5"
                      onChange={handleChange}
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
